module.exports = __webpack_public_path__ + "img/logo.a0236d19.svg";